import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
} from '@angular/common/http';
import {
  MenuController,
  ActionSheetController,
  ModalController,
  AlertController,
  NavParams,
  NavController,
  IonicRouteStrategy,
  IonicModule,
} from '@ionic/angular';
import { RouteReuseStrategy } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// seus serviços
import { UtilService } from './app/services/util/util-service';
import { UsuarioService } from './app/services/user/usuario-service';
import { SgaService } from './app/services/sga/sga';
import { VeiculoService } from './app/services/vehicle/veiculo-service';
import { Events } from './app/services/Events';

import { AppComponent } from './app/app.component';
import { routes } from './app/routes';
import { provideRouter } from '@angular/router';

defineCustomElements(window);

// enableProdMode(); // ative se estiver pronto para produção

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      IonicModule.forRoot(),
      FormsModule,
      TranslateModule.forRoot({ defaultLanguage: 'en' }),
    ),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),

    // Serviços personalizados
    HttpClient,
    UtilService,
    UsuarioService,
    SgaService,
    VeiculoService,
    Events,

    // Controllers Ionic
    MenuController,
    ActionSheetController,
    ModalController,
    AlertController,
    NavParams,
    NavController,

    // Roteamento Ionic
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
}).catch((err) => console.error(err));
